module.exports = __webpack_public_path__ + "img/file-manager.be635858.png";